import React from 'react'
import { Container, Label, Name, Value, ReferenceValue } from './styles'
import { Complement } from '../Complement'
import { isLaboratoryTestPropertyAltered } from '~/utils/laboratoryTest'

const EMPTY = ''

interface IProps {
  name: string
  value?: string | number
  referenceValue?: string
  interpretation?: string
  complement?: string
}

export const QualitativeProperty = (props: IProps): JSX.Element => {
  const { name, value, referenceValue, interpretation, complement } = props

  return (
    <Container>
      <Label
        data-testid="qualitative-property-label"
        isPropertyAltered={isLaboratoryTestPropertyAltered(interpretation)}
      >
        <Name>{`${name.trim()}: `}</Name>
        {value && <Value>{value}</Value>}
      </Label>

      {referenceValue && <ReferenceValue>{`Ref.: ${referenceValue}`}</ReferenceValue>}

      <Complement text={complement ?? EMPTY} />
    </Container>
  )
}
